<template>
  <v-dialog
    v-model="show"
    width="800"
    persistent
    @keydown.esc="closeModal"
  >
    <v-card elevation="0">
      <v-card-title class="app-card-title">
        <span>Campos do documento: {{ documentType.name }}</span>
      </v-card-title>
      <v-card-text class="app-card-content">
        <section
          v-if="isFetching"
          class="loading"
        >
          <v-progress-circular
            indeterminate
            color="success"
          />
          <span>Carregando campos ...</span>
        </section>

        <v-form
          v-else
          ref="form"
          lazy-validation
          @submit.prevent="onSubmit"
        >
          <p
            v-if="!fields.length"
            class="mb-4"
          >
            Nenhum campo cadastrado para este documento.
          </p>

          <v-row
            v-for="(field, index) in fields"
            :key="index"
            dense
          >
            <v-col
              :lg="3"
              :md="3"
              :sm="6"
            >
              <v-text-field
                v-model="field.name"
                outlined
                dense
                hide-details="auto"
                label="Nome *"
                placeholder="Ex:. Data de Validade"
                :rules="[rules.required]"
                :disabled="!canEdit"
              />
            </v-col>
            <v-col
              :lg="3"
              :md="3"
              :sm="6"
            >
              <v-text-field
                v-model="field.code"
                outlined
                dense
                hide-details="auto"
                label="Código *"
                placeholder="Ex:. expired_at"
                :rules="[rules.required]"
                :disabled="!canEdit"
              />
            </v-col>
            <v-col
              :lg="2"
              :md="2"
              :sm="6"
            >
              <v-select
                v-model="field.kind"
                :items="kindOptions"
                outlined
                dense
                hide-details="auto"
                label="Tipo *"
                :rules="[rules.required]"
                :disabled="!canEdit"
              />
            </v-col>
            <v-col
              :lg="3"
              :md="3"
              :sm="6"
            >
              <v-text-field
                v-model="field.external_code"
                outlined
                dense
                hide-details="auto"
                label="Código Externo"
                placeholder="Ex:. dataValidade"
                :disabled="!canEdit"
              />
            </v-col>
            <v-col
              :lg="1"
              :md="1"
              :sm="6"
              class="d-flex align-center"
            >
              <v-icon
                v-if="canEdit"
                small
                color="red"
                @click="removeField(index)"
              >
                delete
              </v-icon>
            </v-col>
          </v-row>

          <v-btn
            v-if="canEdit"
            small
            depressed
            outlined
            color="success"
            class="mt-2"
            @click="addField"
          >
            Adicionar campo
          </v-btn>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          color="error"
          :disabled="isSaving"
          @click="closeModal"
        >
          {{ canEdit ? 'Cancelar' : 'Fechar' }}
        </v-btn>
        <v-btn
          v-if="canEdit"
          text
          color="success"
          :loading="isSaving"
          :disabled="isFetching"
          @click="onSubmit"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex';
  import TipoDocumentoService from '@/services/tipo-documento.service';

  export default {
    name: 'TypeSolicitationTypeDocumentFieldsModal',

    props: {
      documentType: {
        type: Object,
        required: true,
      },
    },

    data: () => ({
      show: true,
      isFetching: false,
      isSaving: false,

      fields: [],

      kindOptions: [
        { text: 'Texto', value: 'text' },
        { text: 'Data', value: 'date' },
      ],

      rules: {
        required: value => !!value || 'Esse campo deve ser preenchido'
      },
    }),

    computed: {
      ...mapState('global', ['user']),

      canEdit() {
        const { functionalities = [] } = this.user || {};
        return functionalities.includes('update_type_document');
      },
    },

    mounted() {
      this.fetchDocumentType();
    },

    methods: {
      fetchDocumentType() {
        this.isFetching = true;
        TipoDocumentoService
          .show(this.documentType.id)
          .subscribe((documentType) => {
            this.fields = (documentType.document_fields || []).map(field => ({ ...field }));
            this.isFetching = false;
          }, () => {
            this.isFetching = false;
          });
      },

      addField() {
        this.fields.push({
          name: '',
          code: '',
          kind: 'text',
          external_code: '',
        });
      },

      removeField(index) {
        this.fields.splice(index, 1);
      },

      onSubmit() {
        if (!this.$refs.form.validate()) return;

        this.isSaving = true;
        TipoDocumentoService
          .updateFields(this.documentType.id, this.fields)
          .subscribe(() => {
            this.isSaving = false;
            this.$emit('saved');
            this.$emit('close');
          }, () => {
            this.isSaving = false;
          });
      },

      closeModal() {
        this.show = false;
        this.$emit('close');
      },
    }
  }
</script>
